import React, { useEffect, useState } from "react";

function SectionCard({
  id,
  title,
  description,
  errorCount = 0,
  defaultOpen = true,
  collapsible = false,
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    if (errorCount > 0) {
      setOpen(true);
    }
  }, [errorCount]);

  return (
    <section className="cms-section-card" id={id}>
      <div
        className={`cms-section-card__header${collapsible ? "" : " cms-section-card__header--static"}`}
        onClick={collapsible ? () => setOpen(!open) : undefined}
        role={collapsible ? "button" : undefined}
        tabIndex={collapsible ? 0 : undefined}
        onKeyDown={collapsible ? (e) => e.key === "Enter" && setOpen(!open) : undefined}
      >
        <div>
          <h3 className="cms-section-card__title">{title}</h3>
          {description && <p className="cms-section-card__description">{description}</p>}
        </div>
        <div className="d-flex align-items-center" style={{ gap: 6 }}>
          {errorCount > 0 && (
            <span className="cms-section-card__error-badge">{errorCount}</span>
          )}
          {collapsible && (
            <span className="cms-accordion-toggle">
              <i className={`mdi mdi-chevron-${open ? "up" : "down"}`} />
            </span>
          )}
        </div>
      </div>
      {(!collapsible || open) && <div className="cms-section-card__body">{children}</div>}
    </section>
  );
}

export default SectionCard;
